// The words of the pages today's links lead to when there is nothing to open.
export const linkWords = {
  moved: 'This document moved to the repository:',
  movedTitle: 'Moved to the repository',
  /** Shown as the link when a document's path is the repository's root. */
  repository: 'the repository',
  requestGone: 'This request was on today’s board; it is not carried over.',
  runGone: 'This run was on today’s board; it is not carried over.',
  goneTitle: 'Not carried over',
}
